import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getUserNewCardsCount = (
    state: IApplicationState
): number => {
    const { meta } = getAuthUser(state);
    return meta && meta.newCardsCount || 0;
};
